import classNames from "classnames";
import { componentProps } from "components/baseComponent";
import ScrollAnimated from "components/ScrollAnimated";
import React from "react";

export type ScrollSettings = {};

type Props = componentProps & {
  clippingShapeClass: string; // cant do maskImage inline for some reaosn. doesnt work
  backgroundSrc: string;
  featureImageString: string;
  characterClasses?: string;
  characterMask?: string;
  invertedClipClass?: string;

  characterAnimSettings?: {
    movementSpeed: number;
    start: number;
    target: number;
  };

  backgroundAnimSettings?: {
    movementSpeed: number;
    start: number;
    target: number;
  };
};

export default class HomepagePicture extends React.Component<Props, {}> {
  render() {
    const {
      clippingShapeClass,
      featureImageString,
      backgroundSrc,
      characterClasses,
      characterMask,
      characterAnimSettings,
      backgroundAnimSettings,
    } = this.props;

    return (
      <div
        className={classNames(
          "w-full h-full max-h-[624.02px] max-w-[813.7px] relative"
        )}
      >
        <div
          className={classNames(
            " w-full z-10 bg-cover bg-no-repeat absolute  left-[50%] translate-x-[-50%] ",
            clippingShapeClass
          )}
        >
          <ScrollAnimated
            style={{ backgroundImage: `url('${backgroundSrc}')` }}
            className={classNames(
              "w-full h-[100%] z-10 bg-cover bg-no-repeat absolute  left-[50%] translate-x-[-50%] "
            )}
            movementSpeed={backgroundAnimSettings?.movementSpeed}
            start={backgroundAnimSettings?.start}
            goal={backgroundAnimSettings?.target}
          />
        </div>
        <div
          className={classNames(
            " w-full z-10 bg-contain bg-no-repeat absolute  left-[50%] translate-x-[-50%] ",
            characterMask
          )}
        >
          <ScrollAnimated
            style={{ backgroundImage: `url('${featureImageString}')` }}
            className={classNames(
              "fadeIn w-full z-10 bg-contain bg-no-repeat absolute  left-[50%] translate-x-[-50%] bottom-[-100px] ",
              characterClasses
            )}
            movementSpeed={characterAnimSettings?.movementSpeed}
            start={characterAnimSettings?.start}
            goal={characterAnimSettings?.target}
          />
        </div>
      </div>
    );
  }
}
